import React from 'react';
import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import {
  useGroupedAccountCertifications,
  CertificationGroupType,
} from '@wix/wix-studio-marketplace-lib';
import { PROFILE_MAX_VISIBLE_CERTIFICATIONS_SHORT_DESKTOP } from '@utils/constants';
import CompactCertification from './CertificationDisplay/CompactCertification';
import MoreItemsButton from '../MoreItemsButton';
import s from './Certifications.module.scss';

const renderCompactCertificationGroup = (group: CertificationGroupType) => (
  <CompactCertification key={group} certificationGroup={group} />
);

interface CompactCertificationsProps {
  certifications: PublicCertification[];
  isMobileView?: boolean;
}

const CompactCertifications: React.FC<CompactCertificationsProps> = ({
  certifications,
  isMobileView,
}) => {
  const { t } = useTranslation();
  const { certificationGroups } = useGroupedAccountCertifications({
    accountCertifications: certifications,
  });

  if (!certificationGroups?.length) return null;

  return (
    <Box direction="vertical" dataHook="compact-certifications">
      <Text size="small" weight="thin" dataHook="certifications-title">
        {t('profile-page-certifications-title')}
      </Text>
      <Box marginTop="12px">
        <div className={s.shortDesktop}>
          <MoreItemsButton
            items={certificationGroups}
            maxVisibleItems={PROFILE_MAX_VISIBLE_CERTIFICATIONS_SHORT_DESKTOP}
            isMobileView={isMobileView}
            renderItem={renderCompactCertificationGroup}
          />
        </div>

        <div className={s.regularHeightDesktop}>
          {certificationGroups.map(renderCompactCertificationGroup)}
        </div>
      </Box>
    </Box>
  );
};

export default CompactCertifications;
